module.exports = { "default": require("core-js/library/fn/object/get-own-property-names"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/babel-runtime/6.18.0/babel-runtime/core-js/object/get-own-property-names.js
// module id = 110
// module chunks = 0